<template>
  <img :src="logoUrl" :alt="alt" :title="alt" loading="lazy" class="plain logo" />
</template>

<script>
export default {
  computed: {
    logoUrl() {
      const baseUrl = `/media/logo-${this.mode}`;

      switch (this.mode) {
        case "transparent":
        case "round-big":
          return `${baseUrl}.png`;
        case "square":
        case "white":
          return `${baseUrl}.jpg`;
        case "horizontal":
        case "vertical":
        case "horizontal-white":
        case "vertical-white":
          return `${baseUrl}.svg`;
      }

      return "";
    }
  },
  props: {
    mode: {
      type: String,
      default: "transparent"
    },
    alt: {
      type: String,
      default: "Grid Dynamics"
    }
  }
};
</script>

<style scoped>
.logo {
  background: none;
}
</style>